// @ts-nocheck
/* eslint-disable */
export const addCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><path fill="currentColor" d="M7 .333C3.327.333.333 3.327.333 7S3.327 13.667 7 13.667 13.667 10.673 13.667 7 10.673.333 7 .333M9.667 7.5H7.5v2.167c0 .273-.227.5-.5.5a.504.504 0 0 1-.5-.5V7.5H4.333a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5H6.5V4.333c0-.273.227-.5.5-.5s.5.227.5.5V6.5h2.167c.273 0 .5.227.5.5s-.227.5-.5.5"/></svg>`,
    name: 'add-circle' as const
};